import { LegalPage } from "@/components/LegalPage";

const SECTIONS = [
  {
    heading: "Who we are",
    blocks: [
      { text: "Niagara Callback is a sole proprietorship owned and operated by Carlo Vescio." },
      { text: "8605 Glavcic Drive, Niagara Falls, Ontario, L2H 0B1, Canada" },
      { text: "905-351-7489 · carlo@niagaracallback.ca" },
      { text: "Ontario Business Identification Number: 1001765861" },
    ],
  },
  {
    heading: "What this policy covers",
    blocks: [
      {
        text: "How we handle personal information when you visit niagaracallback.ca, contact us, or when we operate a missed-call text-back service on behalf of a client business.",
      },
    ],
  },
  {
    heading: "Information we collect",
    blocks: [
      {
        lead: "When you visit the website.",
        text: "Nothing beyond what your browser sends automatically. We do not use advertising trackers and we do not sell visitor data.",
      },
      {
        lead: "When you call, text or email us.",
        text: "Your phone number or email address, the time of contact, and whatever you tell us.",
      },
      {
        lead: "When you use our chat widget.",
        text: "Any name, phone number or message you choose to enter.",
      },
      {
        lead: "When you call a business that uses our service.",
        text: "If your call goes unanswered, our system records your phone number, the date and time of the call, and any text messages exchanged. This information belongs to that business. We process it on their behalf.",
      },
      {
        lead: "When you become a client.",
        text: "Business name, address, contact details, business registration and tax numbers, and billing information.",
      },
    ],
  },
  {
    heading: "How we use it",
    blocks: [
      {
        items: [
          "To reply to you",
          "To operate the missed-call text-back service for client businesses",
          "To invoice and keep accounting records as Canadian law requires",
          "To improve how the service works",
        ],
      },
      { text: "We do not use your information for advertising, and we do not build profiles." },
    ],
  },
  {
    heading: "SMS messages",
    blocks: [
      {
        lead: "How we get your number.",
        text: "Only because you called a business that uses our service, or because you gave it to us directly. We do not buy, rent or import phone number lists.",
      },
      {
        lead: "What you receive.",
        text: "When your call is not answered, you receive one text from that business acknowledging the missed call and asking how they can help. If you do not reply, you may receive one follow-up. That is all. We do not send marketing or promotional messages.",
      },
      {
        lead: "Your consent.",
        text: "By calling the business you have made an inquiry, which under Canada's Anti-Spam Legislation permits a reply. You can withdraw it at any time.",
      },
      {
        lead: "How to stop.",
        text: "Reply STOP to any message. You will be removed immediately and permanently, and will not receive further texts. You can also reply HELP, or contact us at 905-351-7489 or carlo@niagaracallback.ca.",
      },
      {
        lead: "Rates.",
        text: "Message and data rates may apply, depending on your mobile plan.",
      },
      {
        text: "We do not sell, rent, trade or share mobile phone numbers or SMS consent data with any third party for marketing purposes. Ever.",
      },
    ],
  },
  {
    heading: "Who we share information with",
    blocks: [
      { text: "Only the service providers needed to run the business, and only as far as they need:" },
      {
        items: [
          "GoHighLevel / LeadConnector, the platform that runs the calling and texting",
          "Telecommunications carriers, to deliver the messages themselves",
          "Our accountant, for tax filing",
        ],
      },
      {
        text: "Each is bound to protect the information. We do not sell personal information to anyone, for any purpose.",
      },
      { text: "We may disclose information if required by law." },
    ],
  },
  {
    heading: "How long we keep it",
    blocks: [
      {
        text: "Client business records for as long as they are a client, then seven years as Canadian tax rules require.",
      },
      {
        text: "Call and message records on behalf of a client business for as long as that business remains a client. When they leave, their records go with them.",
      },
      { text: "Contact details from people who reach out to us, until they ask us to delete them." },
    ],
  },
  {
    heading: "Your rights",
    blocks: [
      {
        text: "Under Canadian privacy law you may ask what personal information we hold about you, ask us to correct it, or ask us to delete it. Write to carlo@niagaracallback.ca and we will respond within thirty days.",
      },
    ],
  },
  {
    heading: "Security",
    blocks: [
      {
        text: "Information is stored in the systems named above, which are protected by passwords and two-factor authentication. No system is perfectly secure, and we do not claim otherwise.",
      },
    ],
  },
  {
    heading: "Children",
    blocks: [
      {
        text: "This service is for businesses. We do not knowingly collect information from anyone under sixteen.",
      },
    ],
  },
  {
    heading: "Changes",
    blocks: [{ text: "If this policy changes, the date at the top changes with it." }],
  },
  {
    heading: "Contact",
    blocks: [
      { text: "Carlo Vescio · Niagara Callback" },
      { text: "8605 Glavcic Drive, Niagara Falls, Ontario, L2H 0B1" },
      { text: "905-351-7489 · carlo@niagaracallback.ca" },
    ],
  },
];

export default function Privacy() {
  return (
    <LegalPage title="Privacy Policy" updated="3 October 2026" sections={SECTIONS} testId="privacy-page" />
  );
}
